import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import axios from 'axios';
import './i18n';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { UserProvider } from './providers/UserContext';
import NavBar from './components/NavBar/NavBar';
import Sidebar from './components/SideBar/Sidebar';
import Home from './components/Home/Home';
import Login from './components/Login/Login';
import FAQ from './components/FAQ/FAQ';
import PrincipalForm from './components/PrincipalForm/PrincipalForm';
import LinkedInCallback from './components/Login/LinkedInCallback';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import Plans from './components/Plans/Plans';
import Payment from './components/Payment/Payment';
import SuccessPayment from './components/Payment/SuccesPayment';
import CancelPayment from './components/Payment/CancelPayment';
import ContactForm from './components/ContactForm/contactForm';
import Error404 from './components/Error404/Error404';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse/TermsOfUse';

const stripePromise = loadStripe('tu_clave_publica_de_stripe');

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasIdNegocio, setHasIdNegocio] = useState(false);
  const [isPremium, setIsPremium] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    console.log("REVEAT WEB V1.2");
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUser(user);
        try {
          const response = await axios.get(`${apiUrl}/collections/user/${user.uid}`);
          setHasIdNegocio(!!response.data.id_negocio);
          setIsPremium(!!response.data.is_premium);
        } catch (error) {
          console.error('Error al verificar el estado del usuario:', error);
          setHasIdNegocio(false);
          setIsPremium(false);
        }
      } else {
        setUser(null);
        setHasIdNegocio(false);
        setIsPremium(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [apiUrl]);

  // Componente protegido específico para Dashboard
  const ProtectedDashboard = () => {
    if (!user) {
      return <Navigate to="/login" />;
    }
    if (!hasIdNegocio) {
      return <Navigate to="/principal-form" />;
    }
    return <Sidebar />;
  };

  // Componente para el formulario principal
  const PrincipalFormRoute = () => {
    if (!user) {
      return <Navigate to="/login" />;
    }
    if (hasIdNegocio) {
      return <Navigate to="/dashboard" />;
    }
    return <PrincipalForm setHasIdNegocio={setHasIdNegocio} />;
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <UserProvider>
      <Elements stripe={stripePromise}>
        <Router>
          <div className="App">
            <NavBar user={user} />

            <Routes>
              {/* Ruta principal redirige a Home */}
              <Route path="/" element={<Home />} />

              {/* Rutas públicas */}
              <Route path="/home" element={<Home />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/login" element={<Login />} />

              {/* Rutas protegidas */}
              <Route path="/dashboard" element={<ProtectedDashboard />} />
              <Route path="/principal-form" element={<PrincipalFormRoute />} />
              <Route path="/payment" element={<Payment />} />
              
              {/* Rutas de callback y pago */}
              <Route path="/linkedin-callback" element={<LinkedInCallback />} />
              <Route path="/success-payment" element={<SuccessPayment />} />
              <Route path="/cancel-payment" element={<CancelPayment />} />

              {/* Ruta 404 */}
              <Route path="*" element={<Error404 />} />
            </Routes>
          </div>
        </Router>
      </Elements>
    </UserProvider>
  );
}

export default App;